// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"164b292d","984":"cb6de456"}[chunkId] + ".chunk.css";
};